export default __webpack_public_path__ + "img/75363af3ea1e050f369fd88a7ca28123.svg";